import { createTheme } from '@mui/material/styles';

// Nova paleta de cores
const palette = {
  primary: {
    light: '#5662D6',
    main: '#2939C7', // Azul profundo
    dark: '#1F2A9A',
    contrastText: '#fff',
  },
  secondary: {
    light: '#3D97D1',
    main: '#0E74B7', // Azul médio
    dark: '#095682',
    contrastText: '#fff',
  },
  success: {
    light: '#B4E46A',
    main: '#9CD93F', // Verde limão
    dark: '#7DAF32',
    contrastText: '#05273E',
  },
  error: {
    light: '#ff686b',
    main: '#ff4d4f', // Vermelho coral
    dark: '#e03a3c',
    contrastText: '#fff',
  },
  warning: {
    light: '#ffcf5c',
    main: '#ffbd3d', // Amarelo vibrante
    dark: '#e0a334',
    contrastText: '#05273E',
  },
  info: {
    light: '#3D97D1',
    main: '#0E74B7', // Azul médio (reutilizado)
    dark: '#095682',
    contrastText: '#fff',
  },
  background: {
    default: '#f9fafc',
    paper: '#ffffff',
  },
  text: {
    primary: '#05273E', // Azul escuro (quase preto)
    secondary: '#0E74B7', // Azul médio
    disabled: '#a0aec0',
  },
};

// Cores para os agentes no mapa (adaptadas à nova paleta)
export const agentColors = [
  '#2939C7', // Azul profundo (primário)
  '#0E74B7', // Azul médio (secundário)
  '#9CD93F', // Verde limão (sucesso)
  '#FF6200', // Laranja (complementar)
  '#8A2BE2', // Roxo
  '#00B8D4', // Ciano
  '#FF4D4F', // Vermelho coral
  '#FFBD3D', // Amarelo vibrante
  '#05273E', // Azul escuro (quase preto)
  '#00BFA5', // Turquesa
  '#FF6D00', // Laranja profundo
  '#46BFA9', // Verde-azulado
];

// Criar o tema MUI
const theme = createTheme({
  palette,
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.8rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.2rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 16px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: palette.primary.dark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        },
      },
    },
  },
});

export default theme;